<ng-container *ngIf="contentlet$ | async as contentlet">
  <ng-container *ngFor="let content of contentlet.blogContent.content">
    <ng-container *ngIf="content.identifier">
      <custom-dot-cms-content-render [contentlet]="content"></custom-dot-cms-content-render>
    </ng-container>
    <ng-container *ngIf="content.type">
      <custom-dot-cms-block-editor-content-render [content]="content"></custom-dot-cms-block-editor-content-render>
    </ng-container>
  </ng-container>
</ng-container>
